
function heroUnit() {
    let itemToAnimate = document.querySelectorAll('.animate-text');

    itemToAnimate.forEach(el => {
        let text = el.textContent;
        let initialText = text.slice(0, text.lastIndexOf("["));

        // Getting the text between [  ]
        let str = text.substring(
            text.indexOf("[") + 1, 
            text.lastIndexOf("]")
        );

        // Creating array for each word (after comma)
        let result = str.split(',');
        
        // Select text between [  ]
        let strToRemove = text.slice(text.indexOf("["), text.lastIndexOf("]") + 1);

        // Replacing text with void
        el.textContent = text.replace(strToRemove, '');
        el.textContent = el.textContent.replace(initialText, '');
        
        let wrapper = document.createElement('span');
        wrapper.classList.add('animation-wrapper');
        el.prepend(wrapper);

        let itemWidth = 0;


        // POPULATING SPANS
        result.forEach(item => {
            let span = document.createElement('span')
            span.innerHTML = item.replace(/ /g,'');
            wrapper.prepend(span);
        })

        // Add initial text back
        el.prepend(initialText);


        let spans = el.querySelectorAll('.animation-wrapper span');
        let i = spans.length-1;

        let animateWords = () => {
            el.querySelectorAll('span.active').forEach(item => {
                item.classList.remove('active')
            })
            
            spans[i].classList.add('active');

            spans.length > i+1 ? i++ : i=0;
        }

        animateWords();

        setInterval(() => {
            animateWords();
        }, 2000)


        // Show the item
        el.classList.add('show');

        console.log(result);
    })
}

export { heroUnit };
